export const examOptions = [
    { icon: '🏥', text: '健康加值 | 自費健檢', value: 'out-of-pocket', description: '完整的健康檢查方案，為個人需求提供專業檢測', color: '#207868' },
    { icon: '🏛️', text: '政府補助 | 預防保健', value: 'gov-subsidized', description: '政府提供的預防保健服務，符合資格者可享補助', color: '#2a9d8f' },
    { icon: '🔬', text: '長照體檢', value: 'long-term-care', description: '專為長期照護需求設計的專業健檢服務', color: '#3eb396' },
    { icon: '🛡️', text: '保險體檢', value: 'insurance', description: '配合保險公司需求的專業體檢服務', color: '#52c9a4' },
    { icon: '💊', text: '婦科健檢', value: 'gynecology', description: '專為女性設計的婦科檢查及健康評估', color: '#66dfb2' },
    { icon: '🫀', text: '心血管健檢', value: 'cardiovacular', description: '心臟及血管功能專業檢測，預防心血管疾病', color: '#4ab599' },
    { icon: '🧬', text: '神經系統檢查', value: 'neurology', description: '腦部及神經系統功能評估，早期發現異常', color: '#2f8a78' },
    { icon: '🦴', text: '骨密度檢測', value: 'bone-density', description: '骨質密度測量，預防骨質疏鬆症', color: '#58b8a3' },
];

export const mockOutOfPocket = [
    { text: '青春活力健康基礎', value: 'teen-package', description: '2000 元', color: '#58b8a3' },
    { text: '壯年男性專屬健檢', value: 'adult-male', description: '4000 元', color: '#58b8a3' },
    { text: '輕熟女性全方位保養', value: 'adult-female', description: '6000 元', color: '#58b8a3' },
    { text: '其他需求，需進階諮詢', value: 'customize', color: '#58b8a3' },
]

export const mockSteps = {

}